import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '../hooks/useAuth';
import MenuBar from './MenuBar';
import { useToggleStore } from '../hooks/useTogger';
interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { width } = useToggleStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex">
      <MenuBar />
      <div
        style={{
          width: `calc(100vw - ${width}px)`,
          transition: 'width 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        className="flex flex-col h-[100vh]"
      >
        {children}
      </div>
    </div>
  );
};

export default ProtectedRoute;
